// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { IconCalendar, IconClipboardCheck, IconDashboard, IconListDetails } from '@tabler/icons';

// constant
const icons = {
    IconClipboardCheck,
    IconCalendar,
    IconDashboard,
    IconListDetails
};

// ==============================|| GENERAL - MENU ITEMS ||============================== //

const general = {
    id: 'general-route',
    title: <FormattedMessage id="SYS00000" />,
    type: 'group',
    children: [
        {
            id: 'general-dashboard',
            title: <FormattedMessage id="DAS00001" />,
            type: 'item',
            url: '/',
            icon: icons.IconDashboard
        },
        {
            id: 'general-calendar',
            title: <FormattedMessage id="CAA00001" />,
            type: 'item',
            url: '/calendario/attivita',
            icon: icons.IconClipboardCheck
        },
        {
            id: 'general-current-week',
            title: <FormattedMessage id="CUW00001" />,
            type: 'item',
            url: '/settimana/corrente',
            icon: icons.IconCalendar
        },
        {
            id: 'general-scheduler',
            title: <FormattedMessage id="SCH00001" />,
            type: 'item',
            url: '/schedulatore',
            icon: icons.IconListDetails
        }
    ]
};

export default general;